var map = {
	"./add-screens-active.svg": 12570,
	"./add-screens.svg": 89940,
	"./add-user.svg": 53101,
	"./add-workspace.svg": 18184,
	"./add.svg": 74567,
	"./archive.svg": 56384,
	"./arrow.svg": 967,
	"./artboard.svg": 82130,
	"./asc.svg": 27351,
	"./avatars/bear.svg": 49057,
	"./avatars/fox.svg": 75632,
	"./avatars/kangaroo.svg": 35065,
	"./avatars/lion.svg": 47079,
	"./avatars/octopus.svg": 78723,
	"./avatars/rabbit.svg": 25509,
	"./avatars/ram.svg": 94006,
	"./avatars/seahorse.svg": 27285,
	"./avatars/swan.svg": 71534,
	"./avatars/toucan.svg": 67359,
	"./axure-cloud-logo.svg": 24606,
	"./axure-logo.svg": 87103,
	"./axure-rp-logo.svg": 19357,
	"./axure_page.svg": 71955,
	"./axure_page_overview.svg": 22979,
	"./baloon.svg": 83863,
	"./bell.svg": 80024,
	"./business.svg": 83917,
	"./cactus.svg": 51184,
	"./camera.svg": 69382,
	"./caret.svg": 50466,
	"./checkmark-circle.svg": 15323,
	"./checkmark.svg": 48133,
	"./chrome-close.svg": 82370,
	"./chrome-maximize.svg": 95462,
	"./chrome-minimize.svg": 57538,
	"./chrome-restore.svg": 59898,
	"./close.svg": 26847,
	"./cloud.svg": 2093,
	"./collapse.svg": 57846,
	"./compass.svg": 72988,
	"./copy-link-flipped.svg": 7421,
	"./copy-link.svg": 53217,
	"./copy.svg": 18104,
	"./delete.svg": 12166,
	"./discussion.svg": 58347,
	"./document.svg": 8545,
	"./dot.svg": 96212,
	"./download.svg": 55398,
	"./dsc.svg": 53395,
	"./edit.svg": 47589,
	"./emojis-activity.svg": 78863,
	"./emojis-flags.svg": 86772,
	"./emojis-foods.svg": 22107,
	"./emojis-frequent.svg": 25949,
	"./emojis-nature.svg": 30178,
	"./emojis-objects.svg": 31930,
	"./emojis-people.svg": 32491,
	"./emojis-places.svg": 27733,
	"./emojis-symbols.svg": 81433,
	"./exclamation-circle.svg": 45084,
	"./expo-empty-state.svg": 91621,
	"./eye.svg": 9911,
	"./figmaapp.svg": 33252,
	"./filter.svg": 55722,
	"./filter_off.svg": 43659,
	"./filter_on.svg": 79990,
	"./folder.svg": 11351,
	"./gear.svg": 16127,
	"./grid.svg": 30829,
	"./help.svg": 5612,
	"./home.svg": 39555,
	"./imageapp.svg": 43996,
	"./images.svg": 27516,
	"./info.svg": 91203,
	"./interaction.svg": 24430,
	"./jira-close.svg": 38483,
	"./jira-edit.svg": 78399,
	"./jira-expand.svg": 67877,
	"./jira-open.svg": 63725,
	"./list.svg": 95040,
	"./lock.svg": 90570,
	"./masters-empty-state.svg": 17698,
	"./mention.svg": 1972,
	"./menu.svg": 67230,
	"./my-projects.svg": 83845,
	"./not-shared.svg": 47509,
	"./notes.svg": 96039,
	"./overflow-vertical.svg": 44924,
	"./overflow.svg": 73387,
	"./plus.svg": 59156,
	"./pointer.svg": 77657,
	"./project-error.svg": 29959,
	"./project-library-10-lg.svg": 38442,
	"./project-library-10-sm.svg": 33765,
	"./project-library-6-lg.svg": 87517,
	"./project-library-6-sm.svg": 5979,
	"./project-library-7-lg.svg": 38374,
	"./project-library-7-sm.svg": 58660,
	"./project-library-8-lg.svg": 32167,
	"./project-library-8-sm.svg": 22058,
	"./project-library-9-lg.svg": 64477,
	"./project-library-9-sm.svg": 76683,
	"./project-library-lg.svg": 16753,
	"./project-library-sm.svg": 48523,
	"./project-rp-10-lg.svg": 83555,
	"./project-rp-10-sm.svg": 73134,
	"./project-rp-6-lg.svg": 87314,
	"./project-rp-6-sm.svg": 74178,
	"./project-rp-7-lg.svg": 65484,
	"./project-rp-7-sm.svg": 54582,
	"./project-rp-8-lg.svg": 85187,
	"./project-rp-8-sm.svg": 33494,
	"./project-rp-9-lg.svg": 63856,
	"./project-rp-9-sm.svg": 12194,
	"./project-rp-lg.svg": 43262,
	"./project-rp-sm.svg": 883,
	"./project-rp8.svg": 63502,
	"./project-teamlib-10-lg.svg": 62739,
	"./project-teamlib-10-sm.svg": 51633,
	"./project-teamlib-6-lg.svg": 26520,
	"./project-teamlib-6-sm.svg": 49220,
	"./project-teamlib-7-lg.svg": 12822,
	"./project-teamlib-7-sm.svg": 31292,
	"./project-teamlib-8-lg.svg": 36049,
	"./project-teamlib-8-sm.svg": 93243,
	"./project-teamlib-9-lg.svg": 50605,
	"./project-teamlib-9-sm.svg": 60271,
	"./project-teamlib-lg.svg": 40775,
	"./project-teamlib-sm.svg": 42176,
	"./project-teamrp-10-lg.svg": 66620,
	"./project-teamrp-10-sm.svg": 81678,
	"./project-teamrp-6-lg.svg": 35350,
	"./project-teamrp-6-sm.svg": 34186,
	"./project-teamrp-7-lg.svg": 21055,
	"./project-teamrp-7-sm.svg": 76340,
	"./project-teamrp-8-lg.svg": 41334,
	"./project-teamrp-8-sm.svg": 41799,
	"./project-teamrp-9-lg.svg": 41570,
	"./project-teamrp-9-sm.svg": 70510,
	"./project-teamrp-lg.svg": 7931,
	"./project-teamrp-sm.svg": 99832,
	"./recents.svg": 96452,
	"./remove.svg": 78028,
	"./rulers.svg": 86458,
	"./scrubber-active.svg": 86900,
	"./scrubber.svg": 97265,
	"./search.svg": 39045,
	"./settings-lg.svg": 85919,
	"./settings-sm.svg": 27921,
	"./settings.svg": 50791,
	"./share-logo.svg": 12776,
	"./share.svg": 641,
	"./shield.svg": 82209,
	"./sitemap-panel.svg": 67083,
	"./sketch-project-logo.svg": 51529,
	"./sketchapp-square.svg": 71541,
	"./sketchapp.svg": 54393,
	"./smiley-face.svg": 63464,
	"./star-outlined.svg": 38033,
	"./star.svg": 7579,
	"./trashcan.svg": 71768,
	"./uncollapse.svg": 55274,
	"./unsorted.svg": 95466,
	"./uploading-cancel.svg": 40880,
	"./uploading-completed.svg": 49360,
	"./users.svg": 6187,
	"./woman-with-binoculars.svg": 65075,
	"./workspace.svg": 53713,
	"./wrench.svg": 18677,
	"./xdapp.svg": 78301
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92498;